import {
    getBrowserLanguage,
    getBrowserTimeZone,
    getDeepLink,
} from "../../utils";
import { CreateRemoteBrowserResponse } from "@amzn/ermine-server-side-rendering-client";
import { getLogger } from "../../utils/ermineLoggerUtils";
import { useMutation } from "@tanstack/react-query";
import { isEmptyList } from "../../utils/commonUtils";
import { sendCreateRemoteBrowserCommand } from "../../utils/ermineSsrClientUtil";
import { getFormattedSdkErrorMessage } from "../../utils/errorUtils";
import { ServiceException } from "@smithy/smithy-client";
import { CookieList } from "../../types/cookies";

export const useCreateRemoteBrowser = () => {
    const result = useMutation<
        CreateRemoteBrowserResponse,
        ServiceException,
        { portalArn: string; cookies?: CookieList }
    >({
        mutationFn: async ({ portalArn, cookies }) => {
            try {
                return await sendCreateRemoteBrowserCommand({
                    portalArn,
                    sessionConfig: {
                        supportedLanguage: getBrowserLanguage(),
                        timeZone: getBrowserTimeZone(),
                        deepLink: getDeepLink(),
                    },
                    cookies: isEmptyList(cookies)
                        ? null
                        : JSON.stringify(cookies),
                });
            } catch (err) {
                await getLogger().error(
                    err
                        ? getFormattedSdkErrorMessage(err, "OidcBrowserCreator")
                        : "Failed to create streaming endpoint"
                );
                throw err;
            }
        },
    });

    return result.mutateAsync;
};
